import { DesktopSectionToolbar } from "@/shared/ui/navigation/DesktopSectionToolbar";

interface DesktopHistoryToolbarProps {
  mode: "viewed" | "posted";
  isFetching: boolean;
  onRefresh: () => void;
  onToggleSidebar: () => void;
  onScrollToTop: () => void;
  onScrollToBottom: () => void;
  onSettingsClick: React.MouseEventHandler<HTMLAnchorElement>;
}

/** カタログと同じ外観で、履歴ページに有効な操作だけを表示する。 */
export function DesktopHistoryToolbar({
  mode,
  isFetching,
  onRefresh,
  onToggleSidebar,
  onScrollToTop,
  onScrollToBottom,
  onSettingsClick,
}: DesktopHistoryToolbarProps): React.ReactElement {
  return (
    <DesktopSectionToolbar
      activeDestination={mode === "viewed" ? "history" : undefined}
      ariaLabel="履歴ナビゲーション"
      isFetching={isFetching}
      onRefresh={onRefresh}
      onToggleSidebar={onToggleSidebar}
      onScrollToTop={onScrollToTop}
      onScrollToBottom={onScrollToBottom}
      onSettingsClick={onSettingsClick}
      secondaryAriaLabel="履歴操作"
    />
  );
}
